module.exports = __webpack_public_path__ + "img/futuric.8eabc0c9.png";